import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: auto;
  color: ${({ theme }) => theme.palette.grey1100};
  position: relative;
`;
export const NoteWrapper = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.palette.grey100};
  padding: 16px;
  border-radius: 8px;
  margin: 24px 0;
  display: flex;
  align-items: center;
`;
export const Note = styled.span`
  font-size: 14px;
  margin-left: 12px;
  color: ${({ theme }) => theme.palette.grey1100};
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  column-gap: 50px;
`;
export const VerticalLine = styled.div`
  border-left: 2px solid ${({ theme }) => theme.palette.lightBlueGrey};
  height: 175px;
`;
export const TotalScoringWrapper = styled.div`
  width: 242px;
  height: 196px;
  box-shadow: 0px 0px 8px rgba(0, 17, 68, 0.08);
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    height: 100px;
    border-radius: 8px;
  }
`;
export const ScoringContainer = styled.div`
  display: flex;
  justify-content: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: space-between;
    margin: 10px;
    align-items: center;
  }
`;
export const Center = styled.div`
  margin-top: 40px;
`;
export const Span = styled.span`
  color: ${({ theme }) => theme.palette.grey800};
  font-size: 24px;
  font-weight: 700;
  margin-top: 15px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
    margin-top: 20px;
  }
`;
export const Text = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  display: flex;
  justify-content: center;
  font-size: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
  }
`;
export const TitleText = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  display: flex-start;
  justify-content: center;

  font-size: 14px !important;
  font-weight: 600 !important;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
  }
`;
export const ScorText = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  display: flex-start;
  justify-content: center;
  font-size: 28px !important;
  font-weight: 700 !important;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px !important;
  }
`;
export const Scoring = styled.div`
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.palette.green600};

  font-size: 40px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: grid;
    text-align: center;
  }
`;
export const TooltipContainer = styled.div`
  display: flex;
  justify-content: revert;
  align-items: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: space-evenly;
  }
`;
export const ReviewContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 8px;
`;
export const PercentContainer = styled.div`
  margin-left: auto;
`;
export const TooltipTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  display: flex;
  width: 150px;
  justify-content: space-between;
  color: ${({ theme }) => theme.palette.grey1100};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
  }
`;
export const ScoringLine = styled.div`
  margin: 4px;
  min-height: 5px;
  border-radius: 4px;
  flex-direction: row-reverse;

  display: flex;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-right: 12px;
    flex-direction: row;
  }
`;
export const PercentWrapper = styled.div`
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
export const Percent = styled.span`
  font-size: 14px;
  font-weight: 600;
  padding-left: 40px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
  }
`;
export const ReviewsNumber = styled.span`
  font-size: 14px;
  font-weight: 600;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 14px;
  }
`;
export const CommentTitle = styled.span<{ isName?: boolean }>`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.grey1100};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    ${({ isName }) => isName && `font-size: 10px;`}
  }
`;
export const CommentDesc = styled.span<{ isLight?: boolean }>`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme, isLight }) =>
    isLight ? theme.palette.grey800 : theme.palette.grey1100};
`;
export const CommentContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const Examination = styled.div`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  padding: 8px;
  border-radius: 4px;
`;

export const SpeacialHotelWrapper = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 20px;
    margin-bottom: 20px;
  }
`;
export const ScoreContainer = styled.div`
  margin-left: -12px;
`;
export const CommentsWrapper = styled.div`
  margin-top: 24px;
  border: solid ${({ theme }) => theme.palette.grey300} !important;
  border-radius: 8px;
  padding: 24px;
`;
export const ReadMoreText = styled.a`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.coral};
  background-color: transparent;
  border: none;
  cursor: pointer;
  left: 0px;
`;

export const ProgressBarContainer = styled.div<{ width?: string }>`
  height: 8px;
  width: ${({ width }) => `${width}`};
  border-radius: 3px;
  background-color: ${({ theme }) => theme.palette.grey300};
  overflow: hidden;
  min-width: 50px;
`;

export const Filler = styled.div<{ progress?: number }>`
  height: 100%;
  background-color: ${({ theme }) => theme.palette.grey800};
  width: ${({ progress }) => `${progress}%`};
  transition: width 0.2s ease-in;
  border-radius: 3px;
`;
